import TextArea from './TextArea.vue'

export { TextArea }
export default TextArea
